
        <div class="textFieldGroup" [ngClass]="{required: isRequired}">
            <input type="text" #inputEl (blur)="onBlur()" (focus)="onFocus()" [formControl]="control" [readOnly]="readOnly" [ngClass]="{hasValue: valueStr, opened: isOpened, readOnly: readOnly}" autocomplete="off"/>
            <div class="reqMark line"></div>
            <div class="bar"></div>
            <label>{{label}}</label>
            <control-messages [messages]="control|validationErrors"></control-messages>
            <div #calWrap class="calendarWrapper"></div>
        </div>
    